import React from "react";

const QuestionInput = ({
  question,
  answer,
  doctorComment,
  onChange,
  index
}) => {
  if (!answer) {
    return null;
  }

  return (
    <div className="mt-5 mb-5 text-start">
      <div className="flex flex-col space-x-4 divide-x-2 border border-gray-200 p-4">
        <label className="block text-sm font-medium dark:text-white mb-2">
          {question}
        </label>
        <p className="text-xs text-gray-500">
          {answer}
        </p>
      </div>
      <input
        type="text"
        value={doctorComment}
        onChange={(e) => onChange(index, e)}
        className="py-3 px-2 block w-full h-24 border-b-2 border-gray-200 text-sm focus:border-blue-500  focus:border-b-blue-500 focus:ring-0 disabled:opacity-50 disabled:pointer-events-none dark:border-b-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 dark:focus:border-b-gray-600"
        placeholder={`${question} sorusuna cevap ver`}
        aria-describedby="hs-input-helper-text"
        required={true}
      />
    </div>
  );
};

export default QuestionInput;